export default "__VITE_ASSET__0mV_xe03__"